import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import emailjs from 'emailjs-com';
import { FaPhone, FaEnvelope, FaBuilding, FaUser } from 'react-icons/fa';
import { MdSubject } from 'react-icons/md';
import photo from '../../media/img/contact/hombre-de-negocios-que-trabaja-con-la-tableta-en-la-oficina-de-cerca.jpg'

import "./contactComponent.scss"

const ContactComponent = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);
    const formRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('contactInfo__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_52fuglj',
            'template_1zjxlhp',
            formRef.current,
            'IrxFk-gygTG-kN-rM'
        ).then(
            (result) => {
                console.log(result.text);
                formRef.current.reset();
                navigate('/mensaje-enviado');
            },
            (error) => {
                console.log(error.text);
                alert(t('contact.form.errorAlert'));
            }
        );
    };

    return (
        <div className='contactInfo'>
            <div className='contactInfo__imageContainer'>
                <img src={photo} alt={t('contact.header.title')} className="contactInfo__image" />
            </div>
            <div className="lineatop"></div>
            <div className="lineabottom"></div>
            <div className='contactInfo__header'>
                <div className='contactInfo__imagebackground-smallScream'>
                    <div className='contactInfo__imageContainer-smallScream'>
                        <img src={photo} alt={t('contact.header.title')} className="contactInfo__image" />
                    </div>
                    <div className="lineatop-media991"></div>
                    <div className="lineabottom-media991"></div>

                </div>
                <div className='contactInfo__text'>
                    <h1 className='contactInfo__title'>{t('contact.header.title')}</h1>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="contactInfo__title-line"
                    />
                    <p className='contactInfo__parrafo'>
                        {t('contact.header.p1')}
                    </p>
                    <p className='contactInfo__parrafo'>
                        {t('contact.header.p2')}
                    </p>
                    <h2 className='contactInfo__subtitle'>{t('contact.header.subtitle')}</h2>
                </div>
            </div>
            <div className='contactInfo__content'>
                <div className='contactInfo__form'>
                    <form className='form' ref={formRef} onSubmit={sendEmail}>
                        <div className='form__group'>
                            <FaUser className='input__icon' />
                            <input type="text" name="user_name" placeholder={t('contact.form.namePlaceholder')} required />
                        </div>

                        <div className='form__group'>
                            <FaBuilding className='input__icon' />
                            <input type="text" name="company" placeholder={t('contact.form.companyPlaceholder')} required />
                        </div>

                        <div className='form__group'>
                            <FaEnvelope className='input__icon' />
                            <input type="email" name="user_email" placeholder={t('contact.form.emailPlaceholder')} required />
                        </div>

                        <div className='form__group'>
                            <FaPhone className='input__icon' />
                            <input type="tel" name="phone" placeholder={t('contact.form.phonePlaceholder')} />
                        </div>

                        <div className='form__group'>
                            <MdSubject className='input__icon' />
                            <input type="text" name="subject" placeholder={t('contact.form.subjectPlaceholder')} />
                        </div>

                        <div className='form__group'>
                            <textarea placeholder={t('contact.form.messagePlaceholder')} name="message" required></textarea>
                        </div>

                        <button type="submit" className='submit__button'>
                            {t('contact.form.submitButton')}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ContactComponent;